import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
export function VerifyEmail() {
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  useEffect(() => {
    // Simulate verification process
    const timer = setTimeout(() => {
      // Randomly succeed or fail for demonstration
      setStatus(Math.random() > 0.2 ? 'success' : 'error');
    }, 2000);
    return () => clearTimeout(timer);
  }, []);
  return <div className="min-h-screen bg-slate-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8 font-sans animate-in fade-in duration-500" data-id="element-767" data-mp="1j301vmyeq5eh">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-768" data-mp="1e8njzhckx24u">
        <div className="bg-white py-10 px-6 shadow-sm border border-slate-200 sm:rounded-xl text-center" data-id="element-769" data-mp="19b446d08ghas">
          {status === 'loading' && <div className="animate-in fade-in zoom-in duration-300" data-id="element-770" data-mp="220ku940drm3u">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-slate-100 mb-4" data-id="element-771" data-mp="21z9q3330wcc7">
                <Loader2 className="h-6 w-6 text-slate-600 animate-spin" data-id="element-772" data-mp="2ajk5zww7cfx5" />
              </div>
              <h2 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-773" data-mp="2fievfhood2q8">
                Verifying your email
              </h2>
              <p className="text-slate-600" data-id="element-774" data-mp="25q99aol3tfiy">
                Please wait a moment while we verify your email address...
              </p>
            </div>}

          {status === 'success' && <div className="animate-in fade-in zoom-in duration-300" data-id="element-775" data-mp="1wqccu0sh3cdc">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-emerald-100 mb-4" data-id="element-776" data-mp="1wngg2fsd2tqh">
                <CheckCircle2 className="h-6 w-6 text-emerald-600" data-id="element-777" data-mp="1mrdepc5c2z4l" />
              </div>
              <h2 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-778" data-mp="3d42vcckca36i">
                Email Verified!
              </h2>
              <p className="text-slate-600 mb-6" data-id="element-779" data-mp="3h669j8ye7lvh">
                Your email address has been successfully verified. You can now
                access all features.
              </p>
              <Link to="/login" className="w-full flex justify-center py-2.5 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-slate-900 hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-900 transition-colors" data-id="element-780" data-mp="oy40ygro903j">
                Continue to Login
              </Link>
            </div>}

          {status === 'error' && <div className="animate-in fade-in zoom-in duration-300" data-id="element-781" data-mp="18mmv7crjb3p3">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4" data-id="element-782" data-mp="13ulbj5s1eap1">
                <XCircle className="h-6 w-6 text-red-600" data-id="element-783" data-mp="yv8ressjvhq5" />
              </div>
              <h2 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-784" data-mp="1wc7gw3f2of22">
                Verification Failed
              </h2>
              <p className="text-slate-600 mb-6" data-id="element-785" data-mp="1rk78rnoumfue">
                The verification link is invalid or has expired. Please request
                a new verification email.
              </p>
              <button onClick={() => setStatus('loading')} className="w-full flex justify-center py-2.5 px-4 border border-slate-300 rounded-md shadow-sm text-sm font-medium text-slate-700 bg-white hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-900 transition-colors" data-id="element-786" data-mp="23w9lc0d6detf">
                Resend Verification Email
              </button>
            </div>}
        </div>
      </div>
    </div>;
}